import { render, staticRenderFns } from "./korToJpn.vue?vue&type=template&id=5ee093dc&scoped=true&"
import script from "./korToJpn.vue?vue&type=script&lang=js&"
export * from "./korToJpn.vue?vue&type=script&lang=js&"
import style0 from "./korToJpn.vue?vue&type=style&index=0&id=5ee093dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee093dc",
  null
  
)

export default component.exports